// DAO + some helper functions

export interface Filters {
  datdeb: string;
  datfin: string;
  numFacture: string;
  recipient: string;
  etats: string[];
  orgAmo: string;
	datcpt: string;
	paiement: string;
}

export function buildFilter(filters: Filters): string {
  const conditions: string[] = [];
  
  if (filters.datdeb) {
    conditions.push(`datdeb:${filters.datdeb}`);
  }
  if (filters.datfin) {
    conditions.push(`datfin:${filters.datfin}`);
  }
  if (filters.numFacture) {
    conditions.push(`numFacture:${filters.numFacture}`);
  }
  if (filters.recipient) {
    conditions.push(`recipient:${filters.recipient}`);
  }
  if (filters.orgAmo) {
    conditions.push(`orgAmo:${filters.orgAmo}`);
  }
  if (filters.datcpt) {
    conditions.push(`datcpt:${filters.datcpt}`);
  }
	
	if (filters.paiement) {
	  conditions.push(`paiement:${filters.paiement}`);
	}	
  
  // L'état est calculé par le client
  // if (filters.etats && filters.etats.length > 0) {
  //   const etatsCondition = filters.etats.map(etat => `etats:${etat}`).join(' OR ');
  //   conditions.push(`(${etatsCondition})`);
  // }
  
  return 'q=' + conditions.join(' AND ');
}
